import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  public exportFromArray(json: any[], excelFileName: string, wscols: any[], addTimestamp: boolean): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    if (wscols != null) {
      worksheet['!cols'] = wscols;
    }
    else {
      worksheet['!cols'] = this.fitToColumn(json)
    }

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName, addTimestamp);
  }

  private saveAsExcelFile(buffer: any, fileName: string, addTimestamp: boolean): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

    if (addTimestamp) {
      fileName = fileName + '_' + new Date().getTime();
    }

    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  private fitToColumn(json: any[]) {

    //var wscols = [];
    // for (var i = 0; i < header.length; i++) {  // columns length added
    //   wscols.push({ wch: header[i].length + 5 })
    // }
    // return wscols;

    var wscols = [];
    let objectMaxLength = [];
    for (let i = 0; i < json.length && i < 50; i++) {
      let value = <any>Object.values(json[i]);
      for (let j = 0; j < value.length; j++) {
        if (typeof value[j] == "number") {
          objectMaxLength[j] = 7;
        }
        // date için eklendi.
        else if (typeof value[j] == "object")  {
          objectMaxLength[j] = 13;
        } else {
          objectMaxLength[j] =
            objectMaxLength[j] >= value[j].length
              ? objectMaxLength[j]
              : value[j].length;
        }
      }
    }

    for (var i = 0; i < objectMaxLength.length; i++) {  // columns length added
      wscols.push({ wch: objectMaxLength[i] + 3 })
    }

    return wscols;
  }





  import(file) {

    const target: DataTransfer = <DataTransfer>(file.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {

      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });


      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const data = <any>(XLSX.utils.sheet_to_json(ws, { header: 1 }));

      return data;
    };
    reader.readAsBinaryString(target.files[0]);
    file.target.value = '';
  }
}
